import { z } from "zod";

import { isoDate } from "./iso-date-schema";

// Enum mimics from your schema — adjust as needed
export const typeEnum = z.enum(["INDIVIDUAL", "ORGANIZATION", "TEST"]);
export const relationshipEnum = z.enum(["CUSTOMER", "VENDOR"]);
export const vendorTypeEnum = z.enum(["IN_HOUSE", "NETWORK"]);
export const statusEnum = z.enum([
  "ACTIVE",
  "PENDING_APPROVAL",
  "DE_ACTIVATED",
]);

export const vendorSchema = z.object({
  id: z.string(),
  uuid: z.string().uuid(),
  accountId: z.string(),
  type: vendorTypeEnum,
  arrivalWindow: z.number().nullable(),
  diagnosticsFee: z.number().nullable(),
  warranty: z.number().int().nullable(),
  isFeeWaive: z.boolean(),
  note: z.string().nullable(),
  status: statusEnum,
});

export const vendorItemSchema = z.object({
  id: z.string().length(24),
  uuid: z.string().uuid(),
  name: z.string(),
  invoicedCustomerId: z.string().nullable(),
  type: typeEnum,
  relationship: relationshipEnum,
  email: z.string().nullable(),
  phone: z.string().nullable(),
  address1: z.string().nullable(),
  address2: z.string().nullable(),
  isArchived: z.boolean(),
  createdAt: isoDate,
  updatedAt: isoDate,
  vendor: vendorSchema.nullable(),
});
